import React from "react";
import PropTypes from "prop-types";
import ExerciseCard from "../exercise/ExerciseCard";

function GhostExerciseCard({ exercise }) {
  return (
    <div
      style={{
        transform: "scale(0.95)",
        opacity: 0.9,
        pointerEvents: "none",
      }}
    >
      <ExerciseCard exercise={exercise} />
    </div>
  );
}

GhostExerciseCard.propTypes = {
  exercise: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default GhostExerciseCard;
